import {
  colorAccent1,
  colorGray,
  colorInfo,
  colorSuccess,
  colorWarning,
} from '@atlas-frontend/design-tokens';

export function getValidationErrorLevelColor(level: string | null) {
  switch (level) {
    case 'ERROR':
    case 'TECH_ERROR':
      return colorAccent1;
    case 'WARNING':
      return colorWarning;
    case 'INFO':
      return colorInfo;
    case 'SUCCESS':
      return colorSuccess;
    case 'NO_RULES':
      return colorGray[5];
    default:
      return undefined;
  }
}
